import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { I18nContext } from '../../I18n'

import styles from './Youtube.module.css'

Youtube.propTypes = {
  video: PropTypes.array
}

Frame.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string
}

export default function Youtube ({ video }) {
  const I18n = useContext(I18nContext)

  return (
    <div className={styles.root}>
      <div className={styles.heading}>
        {I18n.t('pages.index.youtube.title')}
      </div>

      {video.map((v, i) =>
        <Frame
          key={`${v.youtube_id}-${i}`}
          id={v.youtube_id}
          // key={`${v.video_id}-${i}`} // Обновлено на video_id
          // id={v.video_id} // Обновлено на video_id
          title={v.title}
          desc={dayjs.unix(v.created).locale(I18n.locale).format('D MMMM YYYY')}
        />
      )}
    </div>
  )
}

function Frame ({ id, title, desc }) {
  const [active, setActive] = useState(false)

  // Determine the source type based on the ID
  const isYouTube = id && (id.startsWith('https://www.youtube.com') || id.length === 11);
  const isVimeo = id && id.startsWith('https://vimeo.com');
  const isDirectLink = id && !isYouTube && !isVimeo;

  const getVideoEmbedSrc = (id) => {
    console.log('id', id);
    
    if (id.startsWith('vimeo')) {
      return `https://player.vimeo.com/video/${id}` // Укажите правильный embed URL для Vimeo
    } else {
      return `https://www.youtube.com/embed/${id}` // Для YouTube
    }

    // return `https://www.youtube.com/embed/${id}` // Для YouTube

  }

  return (
    <div className={styles.video}>
      <div className={classNames(styles.youtube, { [styles.active]: active })} onClick={() => setActive(true)} >
        {!active &&
          <div className={styles.img}>
            {/* <img src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} /> */}

            {isYouTube && <img src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} alt={title} />}
            {isVimeo && <img src={`https://vumbnail.com/${id}.jpg`} alt={title} />}
            {isDirectLink && <img src="/path/to/default-thumbnail.jpg" alt={title} />}
          </div>
        }

        {/* {active &&
          <iframe
            // src={`https://www.youtube.com/embed/${id}?autoplay=1`}
            // src={id}
            src={getVideoEmbedSrc(id)} // Используйте новую функцию для src

            frameBorder="0"
            allowFullScreen
            allow="autoplay"
          />
        } */}

        {active &&
          <>
            {isYouTube && (
              <iframe
                src={`https://www.youtube.com/embed/${id}?autoplay=1`}
                frameBorder="0"
                allowFullScreen
                allow="autoplay"
              />
            )}
            {isVimeo && (
              <iframe
                src={`https://player.vimeo.com/video/${id}?autoplay=1`}
                frameBorder="0"
                allowFullScreen
                allow="autoplay"
              />
            )}
            {isDirectLink && (
              // <video controls autoPlay>
              //   <source src={id} type="video/mp4" />
              //   Your browser does not support the video tag.
              // </video>
              // <img src={i} alt={i}>

              <embed
              src={id}
              frameBorder="0"
              allowFullScreen
              allow="autoplay"
              />
            )}
          </>
        }
      </div>

      <div className={styles.title}>
        {title}
      </div>

      <div className={styles.title}>
        {id}
      </div>

      <div className={styles.title}>
        <video controls autoPlay>
          <source src={id} type="video/mp4" />
            Your browser does not support the video tag.
        </video>
      </div>

      <div className={styles.title}>
        <iframe
          src={`https://player.vimeo.com/video/${id}?autoplay=1`}
          frameBorder="0"
          allowFullScreen
          allow="autoplay"
        />
      </div>

      <div className={styles.title}>
        <iframe
          src={id}
          frameBorder="0"
          allowFullScreen
          allow="autoplay"
        />
      </div>

      <div className={styles.date}>
        {desc}
      </div>
    </div>
  )
}
